import { ReactElement } from "react";
import { useDisclosure } from "@chakra-ui/react";
import TooltipIconButton, {
  TooltipIconButtonProps,
} from "components/Shared/TooltipIconButton";
import ConfirmModal, { ConfirmModalProps } from ".";

type ConfirmModalIconButtonProps = Omit<TooltipIconButtonProps, "onClick"> &
  Omit<ConfirmModalProps, "isOpen" | "onClose" | "confirmButton"> & {
    renderConfirmButton: (renderProps: { onClose: () => void }) => ReactElement;
  };

export default function ConfirmModalIconButton({
  renderConfirmButton,
  confirmText,
  error,
  label,
  ...rest
}: ConfirmModalIconButtonProps) {
  const { isOpen, onClose, onOpen } = useDisclosure();
  return (
    <>
      <TooltipIconButton {...rest} label={label} onClick={onOpen} />
      <ConfirmModal
        confirmButton={renderConfirmButton({ onClose })}
        {...{
          isOpen,
          onClose,
          confirmText,
          error,
          label,
        }}
      />
    </>
  );
}
